.banner {
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--dark-4);
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--dark-2);
  gap: 10px;

  &.review {
    background: var(--yellow-10);
  }

  &.approved {
    background: var(--green-10);
  }

  &.posting {
    background: var(--growth-10);
  }

  &.failed {
    background: var(--red-10);
  }

  &.posted {
    background: var(--upgrade-10);
  }

  button,
  a {
    span {
      padding: 0 1px 0 2px !important;
    }
  }

  .pillsAndLabel {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .pills {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .action {
    display: flex;
    align-self: self-start;
  }

  .failedPill,
  .accountsToConnectPill {
    cursor: pointer;
  }
}

.pill {
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid var(--dark-4);
  background: var(--dark-8);
  color: var(--dark-60);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  place-self: flex-start;

  &.review,
  &.disconnected {
    border: 1px solid rgba(255, 174, 0, 0.3);
    background: #fbe8b8;
    color: #3f2b00;
    padding: 4px 8px 4px 4px;

    svg {
      margin-bottom: 1px;
    }

    &.warning {
      border: 1px solid var(--dark-8);
      background: #ffc800;
      color: var(--dark-90);
    }
  }

  &.approved {
    background: var(--green-10);
    color: var(--green);
  }

  &.posting {
    background: var(--growth-10);
    color: var(--growth);
  }

  &.failed {
    background: var(--red-10);
    color: var(--red-90);
  }

  &.posted {
    background: var(--upgrade-10);
    color: var(--upgrade);
  }

  &.new {
    background: #d800ec;
    color: var(--light-100);
  }
}

.pillWithWarningCircle {
  display: flex;
  align-items: center;
  gap: 3px;
}

.warningCircle {
  border-radius: 16px;
  border: 1px solid var(--dark-4);
  background: #ffc800;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;

  svg {
    margin-bottom: 2px;
  }
}
